import { LoginForm } from '@/features/auth/components/LoginForm';

export function LoginPage() {
  return <LoginForm />;
}
